export default __webpack_public_path__ + "static/media/img-0021.2552dc32.png";